import { Progress } from './Progress.styles';
import { SIZES } from './Progress.enum';
import { getCircleProgress } from './Progress.helpers';
import type { ProgressCircleProps } from './Progress.d';

const ProgressCircle = ({
  color,
  customLabel,
  maxValue,
  reverse,
  showLabel,
  size = 'small',
  value,
  ...props
}: ProgressCircleProps) => {
  const { circumference, currentPercent, normalizedRadius, offset } = getCircleProgress(
    size,
    value,
    maxValue,
  );

  return (
    <Progress.Component
      aria-valuemax={maxValue}
      aria-valuemin={0}
      aria-valuenow={value}
      data-testid="progresscircle"
      data-hidden={true}
      role="progressbar"
      {...props}
    >
      <Progress.Circle
        data-color={color}
        data-reverse={reverse}
        data-size={size}
        viewBox={`0 0 ${normalizedRadius * 2 + SIZES[size]} ${normalizedRadius * 2 + SIZES[size]}`}
      >
        <circle
          cx="50%"
          cy="50%"
          r={normalizedRadius}
          strokeDasharray={`${circumference} ${circumference}`}
        />

        <circle
          cx="50%"
          cy="50%"
          r={normalizedRadius}
          strokeDasharray={`${circumference} ${circumference}`}
          strokeDashoffset={offset}
        />

        {showLabel && (
          <text alignmentBaseline="middle" className="small" textAnchor="middle" x="50%" y="50%">
            {customLabel || currentPercent}
          </text>
        )}
      </Progress.Circle>
    </Progress.Component>
  );
};

export default ProgressCircle;
